module.exports = __webpack_public_path__ + "static/media/أفضل شركة سياحية في سويسرا.6b6deeaa.jpg";